import styled from "styled-components";

const Footer = styled.footer`
  padding: 20px;
  text-align: center;
  border-top: none;
  background-color: #333;
  padding: 40px 0;
`;

export default Footer;
